import _ from 'lodash';
import ContenfulService from 'web-core/src/contentful-service';

const defaultEntryId = '221lGVdVVSwkE0AW4O8Ok';

export const RECEIVE_CONFIGURATION = 'RECEIVE_CONFIGURATION';

export const receiveConfiguration = configuration => ({
  type: RECEIVE_CONFIGURATION,
  configuration,
});

export function fetchConfiguration(entryId = defaultEntryId) {
  return (dispatch, getState, { apiClient }) => {
    const svc = new ContenfulService({ client: apiClient });
    return svc.getEntryById(entryId)
      .then((response) => {
        const config = _.get(response, 'data.config');
        if (!config) {
          throw new Error(`Unable to find entry ${entryId}`);
        }
        dispatch(receiveConfiguration(config));
        return config;
      });
  };
}
